export type AppointmentBillingLike = {
  billing_mode?: string | null;
  billing_source?: string | null;
  patient_ticket_allocation_id?: string | null;
};

export const PAID_SESSION_LABEL = 'Sessão paga';
export const COURTESY_BILLING_LABEL = 'Cortesia';

export type AppointmentBillingModeUi = 'particular' | 'plano' | 'ticket' | 'courtesy';

/** Consulta sem cobrança (cortesia). */
export function isCourtesyBilling(appt?: AppointmentBillingLike | null): boolean {
  if (!appt) return false;
  return String(appt.billing_mode || '').toLowerCase() === 'courtesy';
}

/** Consulta vinculada a ticket de procedimento (sessão já paga no pacote). */
export function isPaidSessionAppointment(appt?: AppointmentBillingLike | null): boolean {
  if (!appt) return false;
  return (
    appt.billing_source === 'procedure_ticket'
    || appt.billing_mode === 'ticket'
    || !!appt.patient_ticket_allocation_id
  );
}

/** Rótulo curto na agenda, impressão e painel. */
export function billingModeDisplayLabel(appt?: AppointmentBillingLike | null): string {
  if (!appt) return 'Particular';
  if (appt.billing_mode === 'plano') {
    return (appt as { clinic_insurances?: { name?: string } }).clinic_insurances?.name || 'Plano';
  }
  if (isCourtesyBilling(appt)) return COURTESY_BILLING_LABEL;
  if (isPaidSessionAppointment(appt)) return PAID_SESSION_LABEL;
  return 'Particular';
}

export const paidSessionChipSx = {
  bgcolor: '#fef3c7',
  color: '#b45309',
  fontWeight: 700,
  fontSize: '0.68rem',
  height: 24,
  borderRadius: '10px',
} as const;

export const courtesyBillingChipSx = {
  bgcolor: '#f3e8ff',
  color: '#7e22ce',
  fontWeight: 700,
  fontSize: '0.68rem',
  height: 24,
  borderRadius: '10px',
} as const;
